import { Component } from "@angular/core";

@Component({
    selector: 'app-installation',
    templateUrl: './installation.component.html',
    styleUrls: ['./installation.component.css'],
})
export class InstallationComponent{}